import Section1 from './section1/section1'
import Section2 from './section2/section2'
import Section3 from './section3/section3'
import Section4 from './section4/section4'
import Section6 from './section6/section6'
import Section7 from './section7/section7'
import Section8 from './section8/section8'
import Section9 from './section9/section9'
import Section10 from './section10/section10'
import Section11 from './section11/section11'
import Section5 from './section5/section5'

export default [
  {key: 'info', component: Section1},
  {key: 'contacts', component: Section2},
  {key: 'partners', component: Section3},
  {key: 'descriptions', component: Section4},
  {key: 'results-n-indicators', component: Section5 },
  {key: 'finance', component: Section6},
  {key: 'locations', component: Section7},
  {key: 'focus', component: Section8},
  {key: 'links-n-docs', component: Section9},
  {key: 'comments-n-keywords', component: Section10},
  {key: 'reporting', component: Section11}
]

export const sectionLength = 11
